import { render, staticRenderFns } from "./CreateSaleTarget.vue?vue&type=template&id=4bbd53ae"
import script from "./CreateSaleTarget.vue?vue&type=script&lang=js"
export * from "./CreateSaleTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports